import React, { useEffect } from "react";
import SectionMain from "../../components/SectionMain";
import { Hidden } from "@material-ui/core";
import { useUpdateUser } from "../../hooks/useUpdateUser";
import HomeScreenDesktop from "./desktop";
import HomeScreenMobile from "./mobile";

const HomePage = () => {
  const UpdateUser = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    await useUpdateUser();
  };
  useEffect(() => {
    UpdateUser();
  }, []);

  return (
    <SectionMain noPadding>
      <Hidden only={["xs", "sm", "md"]}>
        <HomeScreenDesktop />
      </Hidden>
      <Hidden only={["lg", "xl"]}>
        <HomeScreenMobile />
      </Hidden>
    </SectionMain>
  );
};

export default HomePage;
